<template>
  <div class="grey lighten-5" style="min-height: 100vh; ">

    <!-- Header dinámico — full width -->
    <div :style="{ backgroundColor: blogSettings.bg_color }" class="pa-4 mb-4">
      <v-container>
        <v-row align="center">
          <!-- Izquierda: saludo + título + subtítulo -->
          <v-col cols="12" md="7">
            <p v-if="blogSettings.show_greeting" class="caption mb-0" :style="{ color: blogSettings.text_color }">
              {{ saludo }}
            </p>
            <h1 class="text-h4 font-weight-bold" :style="{ color: blogSettings.text_color }">
              <v-icon large :color="blogSettings.text_color">{{ blogSettings.icon }}</v-icon>
              {{ blogSettings.title }}
            </h1>
            <p class="mb-0" :style="{ color: blogSettings.text_color }">{{ blogSettings.subtitle }}</p>
          </v-col>
          <!-- Derecha: frase motivacional + fecha -->
          <v-col cols="12" md="5" class="d-flex flex-column justify-center"
            :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }">
            <p v-if="blogSettings.motivational_msg" class="font-italic body-2 mb-1"
              :style="{ color: blogSettings.text_color }">
              "{{ blogSettings.motivational_msg }}"
            </p>
            <p v-if="blogSettings.show_date" class="caption mb-0" :style="{ color: blogSettings.text_color }">
              {{ fechaActual }}
            </p>
            <div class="d-flex align-center mt-2" :class="{ 'justify-end': $vuetify.breakpoint.mdAndUp }">
              <!-- Contador con borde -->
              <div class="contador-box mr-3" :style="{ borderColor: blogSettings.text_color }">
                <contador-blog :text-color="blogSettings.text_color" :icon-color="blogSettings.text_color"
                  :icon-size="30"></contador-blog>
              </div>
              <!-- Mapa con borde -->
              <div class="mapa-box" :style="{ borderColor: blogSettings.text_color }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="showMapDialog = true">
                      <v-icon :color="blogSettings.text_color" size="28">mdi-map-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver mapa de visitantes</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>


            <v-col cols="12" md="12" class="pb-0">
                     <!-- Chips de categorías (PC) / Select (mobile) -->
      <v-row class="mb-1">
        <v-col>
          <!-- PC: Chips -->
          <v-chip-group v-if="$vuetify.breakpoint.mdAndUp" v-model="selectedCategoryId" mandatory active-class="grey darken-4 white--text elevation-2">
            <v-chip v-for="cat in categoriasFiltradas" :key="cat.id" :value="cat.id"
              filter label>
              <v-icon left small v-if="cat.icon">{{ cat.icon }}</v-icon>
              {{ cat.name }}
            </v-chip>
          </v-chip-group>
          <!-- Mobile: Select -->
          <v-select v-else v-model="selectedCategoryId" :items="categoriasFiltradas"
            item-text="name" item-value="id" label="Categoría"
            outlined dense hide-details prepend-inner-icon="mdi-folder">
          </v-select>
        </v-col>
      </v-row>
            </v-col>

            <v-col cols="12" class="pt-0" v-if="selectedCategory">
              <!-- Banner categoría — siempre visible, con buscador integrado -->
              <v-card class="category-banner" :img="bannerSrc"
                :color="!bannerSrc ? (selectedCategory.color || 'grey lighten-2') : ''"
                :height="$vuetify.breakpoint.smAndDown ? 200 : 150">
                <div class="banner-overlay pa-3 d-flex flex-column justify-space-between fill-height">
                  <!-- Contenido superior: autor izq / detalles der -->
                  <v-row no-gutters>
                    <!-- Izquierda: Autor -->
                    <v-col cols="12" md="6">
                      <div v-if="selectedCategory.author" class="d-flex align-center">
                        <v-avatar size="44" class="elevation-3 mr-2">
                          <v-img v-if="selectedCategory.author.url_img" :src="authorImageUrl"></v-img>
                          <v-icon v-else size="44" color="white">mdi-account-circle</v-icon>
                        </v-avatar>
                        <div>
                          <p class="white--text font-weight-bold mb-0 body-2">
                            {{ selectedCategory.author.display_name }}
                          </p>
                          <p class="white--text caption mb-0" v-if="selectedCategory.author.specialty">
                            {{ selectedCategory.author.specialty }}
                          </p>
                          <p class="white--text caption mb-0" v-if="selectedCategory.author.experience">
                            {{ selectedCategory.author.experience }}
                          </p>
                        </div>
                      </div>
                    </v-col>
                    <!-- Derecha: Detalles -->
                    <v-col cols="12" md="6"
                      :class="{ 'text-right': $vuetify.breakpoint.mdAndUp, 'mt-2': $vuetify.breakpoint.smAndDown }">
                      <p v-if="selectedCategory.detail_1" class="white--text body-2 mb-0 font-weight-medium">
                        {{ selectedCategory.detail_1 }}
                      </p>
                      <p v-if="selectedCategory.detail_2" class="white--text caption mb-0">
                        {{ selectedCategory.detail_2 }}
                      </p>
                    </v-col>
                  </v-row>

                  <!-- Buscador abajo del banner -->
                  <v-text-field v-model="busquedaTexto" :placeholder="placeholderBusqueda"
                    dense outlined dark prepend-inner-icon="mdi-magnify" clearable
                    hide-details @keyup.enter="buscar" @click:clear="limpiarBusqueda"
                    background-color="rgba(255,255,255,0.15)" class="mt-2">
                  </v-text-field>
                </div>
              </v-card>
            </v-col>

        </v-row>
      </v-container>
    </div>

    <v-container>

     

 

     






      <!-- Grid de posts -->
      <v-row v-if="posts.length">
        <v-col cols="12" sm="6" md="3"  v-for="post in posts" :key="post.id">
          <blog-post-card :post="post" @click="goToDetail(post)"></blog-post-card>
        </v-col>
      </v-row>

      <!-- Sin posts -->
      <v-row v-else-if="!loading">
        <v-col>
          <v-alert type="info" text>
            No hay publicaciones en esta categoría todavía.
          </v-alert>
        </v-col>
      </v-row>

      <!-- Loading -->
      <v-row v-if="loading" justify="center">
        <v-col cols="auto">
          <v-progress-circular indeterminate color="gray"></v-progress-circular>
        </v-col>
      </v-row>

      <!-- Paginación -->
      <v-row v-if="totalPages > 1" justify="center" class="mt-4">
        <v-col cols="auto">
          <v-pagination v-model="page" :length="totalPages" color="gray"
            @input="cargarPosts"></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <!-- Mapa de visitantes dialog -->
    <blog-map-dialog v-model="showMapDialog"></blog-map-dialog>
  </div>
</template>

<script>
import forumService from '@/services/forumService.js';
import BlogPostCard from '@/components/forum/BlogPostCard.vue';
import ContadorBlog from '@/components/forum/ContadorBlog.vue';
import BlogMapDialog from '@/components/forum/BlogMapDialog.vue';

export default {
  name: 'BlogPublicV',
  components: { BlogPostCard, ContadorBlog, BlogMapDialog },
  props: {
    categoria: { type: String, default: null }
  },
  data() {
    return {
      categorias: [],
      posts: [],
      selectedCategoryId: null,
      busquedaTexto: '',
      loading: false,
      page: 1,
      totalPages: 1,
      showMapDialog: false,
      blogSettings: {
        title: 'Blog',
        subtitle: 'Artículos y publicaciones de nuestro equipo',
        motivational_msg: '',
        show_date: true,
        show_greeting: true,
        icon: 'mdi-post-outline',
        bg_color: '#F5F5F5',
        text_color: '#424242'
      }
    };
  },
  computed: {
    categoriasFiltradas() {
      return this.categorias;
    },
    placeholderBusqueda() {
      const cat = this.categorias.find(c => c.id === this.selectedCategoryId);
      return cat ? 'Buscar en ' + cat.name + '...' : 'Buscar en artículos...';
    },
    selectedCategory() {
      return this.categorias.find(c => c.id === this.selectedCategoryId) || null;
    },
    bannerSrc() {
      if (!this.selectedCategory || !this.selectedCategory.banner_url) return '';
      const url = this.selectedCategory.banner_url;
      if (url.startsWith('http')) return url;
      return forumService.getCategoryBannerUrl(this.selectedCategory.id, url);
    },
    authorImageUrl() {
      if (!this.selectedCategory || !this.selectedCategory.author || !this.selectedCategory.author.url_img) return '';
      return forumService.getAuthorImageUrl(this.selectedCategory.author.id, this.selectedCategory.author.url_img);
    },
    saludo() {
      const h = new Date().getHours();
      if (h < 12) return '¡Buenos días!';
      if (h < 18) return '¡Buenas tardes!';
      return '¡Buenas noches!';
    },
    fechaActual() {
      return new Date().toLocaleDateString('es', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
      });
    }
  },
  watch: {
    selectedCategoryId(newId) {
      if (!newId) return;
      this.busquedaTexto = '';
      const cat = this.categorias.find(c => c.id === newId);
      if (cat) {
        const slug = cat.name.toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        const currentRoute = this.$route;
        if (currentRoute.name !== 'blog-categoria' || currentRoute.params.categoria !== slug) {
          this.$router.replace({ name: 'blog-categoria', params: { categoria: slug } }).catch(() => {});
        }
      }
      this.page = 1;
      this.cargarPosts();
    }
  },
  mounted() {
    this.cargarBlogSettings();
    this.cargarCategorias();
  },
  methods: {
    cargarBlogSettings() {
      forumService.getBlogSettings().then(res => {
        const data = res.data;
        if (data && data.active) {
          this.blogSettings = {
            title: data.title || 'Blog',
            subtitle: data.subtitle || '',
            motivational_msg: data.motivational_msg || '',
            show_date: data.show_date,
            show_greeting: data.show_greeting,
            icon: data.icon || 'mdi-post-outline',
            bg_color: data.bg_color || '#FFFFFF',
            text_color: data.text_color || '#00695C'
          };
        }
      }).catch(() => {});
    },
    cargarCategorias() {
      forumService.listarCategorias().then(res => {
        this.categorias = res.data;
        if (this.categoria) {
          // Buscar por slug del nombre o por id
          const found = this.categorias.find(c => {
            const slug = c.name.toLowerCase()
              .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            return slug === this.categoria.toLowerCase() || String(c.id) === this.categoria;
          });
          this.selectedCategoryId = found ? found.id : (this.categorias[0] ? this.categorias[0].id : null);
        } else if (this.categorias.length) {
          this.selectedCategoryId = this.categorias[0].id;
        }
      });
    },
    cargarPosts() {
      if (!this.selectedCategoryId) return;
      this.loading = true;
      const params = { category_id: this.selectedCategoryId, page: this.page };
      if (this.busquedaTexto) {
        params.search = this.busquedaTexto;
      }
      forumService.listarPosts(params).then(res => {
        const data = res.data;
        this.posts = data.data || data;
        this.totalPages = data.last_page || 1;
      }).finally(() => {
        this.loading = false;
      });
    },
    buscar() {
      this.page = 1;
      this.cargarPosts();
    },
    limpiarBusqueda() {
      this.busquedaTexto = '';
      this.page = 1;
      this.cargarPosts();
    },
    goToDetail(post) {
      this.$router.push({ name: 'blog-detail', params: { url_post: post.url_post } });
    }
  }
};
</script>

<style scoped>
/* Chips no seleccionados — mejor contraste */
.v-chip-group .v-chip:not(.grey) {
  background-color: #e0e0e0 !important;
  color: #333 !important;
  border: none !important;
}

.v-chip-group .v-chip:not(.grey):hover {
  background-color: #bdbdbd !important;
}

.category-banner {
  border-radius: 12px !important;
  overflow: hidden;
}

.banner-overlay {
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 50%, transparent 100%);
}

.contador-box {
  border: 1px solid;
  border-radius: 8px;
  padding: 4px 10px;
}

.mapa-box {
  border: 1px solid;
  border-radius: 8px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
}
</style>
